module.exports = __webpack_public_path__ + "static/media/CX.5db39ff5.svg";